// extracted by mini-css-extract-plugin
module.exports = {"text":"datetime_text__29BIg"};